export default "__VITE_ASSET__29227195__"